export enum SidebarType {
  NOTEPAD = 'Notepad',
  COMMENTS = 'Comments',
  RESULT_EXPLAINER = 'Result Explainer',
  EXTERNAL_UPDATES = 'External Updates',
  BUSINESS_EVENTS = 'Business Events',
}

export enum SidebarTitle {
  NOTEPAD = 'Notepad',
  COMMENTS = 'Comments',
  RESULT_EXPLAINER = 'Result Explainer',
  EXTERNAL_UPDATES = 'External Updates',
  BUSINESS_EVENTS = 'Client Signals',
}
